import { render, staticRenderFns } from "./dispatch-car.vue?vue&type=template&id=1e934a9a&scoped=true&"
import script from "./dispatch-car.vue?vue&type=script&lang=js&"
export * from "./dispatch-car.vue?vue&type=script&lang=js&"
import style0 from "./dispatch-car.vue?vue&type=style&index=0&id=1e934a9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e934a9a",
  null
  
)

export default component.exports